<p 
   *iCms="'text' of content; skipEmpty: true"
   class="c1 col-12"
   text
   ></p>